export default {
  SET_PROCESS_LIST (state, playload) {
    state.processList = playload;
  },
  SET_TRADE_TYPE (state, playload) {
    state.tradeType = playload;
  },
  SET_TRANSFER_TYPE (state, playload) {
    state.transferType = playload;
  }
};
